import { useEffect } from "react";

const BASE_URL = "https://wisphomecleaning.ca";
const DEFAULT_IMAGE = `${BASE_URL}/og-share.jpg`;

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const SEO = ({ title, description, canonical, jsonLd, image }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | Wisp Home Cleaning` : "Wisp Home Cleaning — Hamilton & Area";
    document.title = fullTitle;

    if (description) upsertMeta("name", "description", description);

    // Canonical + og:url stay in sync with the current page.
    const url = canonical
      ? canonical.startsWith("http")
        ? canonical
        : `${BASE_URL}${canonical}`
      : `${BASE_URL}${window.location.pathname}`;
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);

    // Per-page Open Graph + Twitter share previews.
    const img = image ? (image.startsWith("http") ? image : `${BASE_URL}${image}`) : DEFAULT_IMAGE;
    upsertMeta("property", "og:title", fullTitle);
    if (description) upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);
    upsertMeta("property", "og:type", "website");
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    if (description) upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", img);

    // Per-page JSON-LD (added on mount, removed on unmount).
    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-page-jsonld", "true");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    window.scrollTo(0, 0);

    return () => {
      if (script && script.parentNode) script.parentNode.removeChild(script);
    };
  }, [title, description, canonical, jsonLd, image]);

  return null;
};
